import { OPEN_DRAWER, CLOSE_DRAWER, SELECT_MENU } from "./types";

const fun= (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case OPEN_DRAWER: {
      console.log("OPEN_DRAWER");
      return {
        ...state,
        //loggeduser: payload,
        DrawerState: true,
      };
    }
    case CLOSE_DRAWER: {
      console.log("Close_DRAWER");
      return {
        ...state,
        //loggeduser: payload,
        DrawerState: false,
      };
    }
    case SELECT_MENU: {
      console.log("SELECT MENU");
      return {
        ...state,
        loggeduser: payload,
        isLogged: true,
      };
    }

    default: {
      console.log("DEFAULT");
      return { state };
    }
  }
};
export default fun

